"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const CalendarTable = (_ref) => {
  let dt = _ref.dt,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["dt", "className"]);

  if (dt) {
    dt = (0, _moment.default)(dt);
  } else {
    dt = (0, _moment.default)();
  }

  const monthStart = (0, _moment.default)(dt).startOf('month').format('YYYY-MM-DD');
  const monthEnd = (0, _moment.default)(dt).endOf('month').format('YYYY-MM-DD');
  const dtStart = (0, _moment.default)(dt).startOf('month').startOf('isoWeek').format('YYYY-MM-DD');
  const dtEnd = (0, _moment.default)(dt).endOf('month').endOf('isoWeek').format('YYYY-MM-DD');
  const weeks = (0, _moment.default)(dtEnd).diff(dtStart, 'week');
  console.log('dt', dt);
  let table = [];

  for (let w = 0; w <= weeks; w++) {
    let datetime = (0, _moment.default)(dtStart).add(w, 'weeks');
    datetime = (0, _moment.default)(datetime).set('hour', 0);
    datetime = (0, _moment.default)(datetime).set('minute', 0);
    datetime = (0, _moment.default)(datetime).set('second', 0);
    let cols = [];
    cols.push(datetime);

    for (let d = 0; d < 6; d++) {
      datetime = (0, _moment.default)(datetime).add(1, 'days').format('YYYY-MM-DD');
      cols.push(datetime);
    }

    table.push(cols);
  }

  const renderWeekday = dt => {
    dt = (0, _moment.default)(dt).format('YYYY-MM-DD');
    const weekday = (0, _moment.default)(dt).format('dddd');
    const ddd = (0, _moment.default)(dt).format('ddd').toUpperCase();
    const dd = (0, _moment.default)(dt).format('dd').toUpperCase();
    const d = (0, _moment.default)(dt).format('dd').substr(0, 1).toUpperCase();

    if (props.renderWeekday) {
      return props.renderWeekday({
        dt: dt,
        weekday: weekday,
        ddd: ddd,
        dd: dd,
        d: d
      });
    }

    return _react.default.createElement("div", null, d);
  };

  const renderDate = dt => {
    dt = (0, _moment.default)(dt).format('YYYY-MM-DD');
    const dtMonth = (0, _moment.default)(dt).isSameOrAfter(monthStart, 'day') && (0, _moment.default)(dt).isSameOrBefore(monthEnd, 'day');

    if (props.renderDate) {
      return props.renderDate({
        dt: dt,
        dtMonth: dtMonth
      });
    }

    return _react.default.createElement("div", null, (0, _moment.default)(dt).format('D'));
  };

  return _react.default.createElement("table", {
    className: className
  }, _react.default.createElement("thead", null, _react.default.createElement("tr", null, table[0].map((date, w) => _react.default.createElement("th", {
    key: w
  }, renderWeekday(date))))), _react.default.createElement("tbody", null, table.map((row, r) => {
    return _react.default.createElement("tr", {
      key: r
    }, row.map((date, c) => _react.default.createElement("td", {
      key: c
    }, renderDate(date))));
  })));
};

var _default = CalendarTable;
exports.default = _default;
module.exports = exports.default;